import React, { useState } from "react";
import "./scss/filter.css";

const FilterWrapper = ({
  title,
  viewType,
  changeViewType,
  filterList = [],
  value,
  onChange,
  view,
}) => {
  const [filters, setFilters] = useState(false);
  const [date, setDate] = useState("");

  const getElement = (element) => {
    switch (element.type) {
      case "select":
        return (
          <select
            className="form-control"
            value={element.value}
            onChange={(e) => onChange(e.target.name, e.target.value)}
            name={element.name}
          >
            <option disabled selected>
              --Select--
            </option>
            {!element.data ? (
              <option>Loading...</option>
            ) : (
              element.data.map((option) => (
                <option value={option}>{option}</option>
              ))
            )}
          </select>
        );
    }
  };

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-5 flex-wrap filter-wrapper ">
        <h3>{title}</h3>
        <div className="right-side d-flex align-items-center">
          {view && (
            <div className="border-wrap d-flex align-items-stretch rounded py-1 px-1 border-wrap">
              <button
                className={`p-2 filter-show d-flex align-items-center border-0 rounded ${
                  !viewType ? "active" : "null"
                }`}
                onClick={() => changeViewType(false)}
              >
                <svg
                  width="18"
                  height="15"
                  viewBox="0 0 18 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0 10.7143H17.1429V8.57143H0V10.7143ZM0 15H17.1429V12.8571H0V15ZM0 6.42857H17.1429V4.28571H0V6.42857ZM0 0V2.14286H17.1429V0H0Z"
                    fill="#042440"
                  ></path>
                </svg>
              </button>
              <button
                className={`p-2 filter-show d-flex align-items-center border-0 rounded ${
                  viewType ? "active" : "null"
                }`}
                onClick={() => changeViewType(true)}
              >
                <svg
                  width="17"
                  height="13"
                  viewBox="0 0 17 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0 6H5V0H0V6ZM0 13H5V7H0V13ZM6 13H11V7H6V13ZM12 13H17V7H12V13ZM6 6H11V0H6V6ZM12 0V6H17V0H12Z"
                    fill="#A8D0E6"
                  ></path>
                </svg>
              </button>
            </div>
          )}
          <div
            className="border-wrap d-flex align-items-center rounded py-2 px-3 border-wrap ml-3"
            onClick={() => setFilters(!filters)}
          >
            <span className="text-primary f-14 mr-3">Filters</span>
            <img
              className="img-fluid float-right"
              src="/img/filter.png"
              alt=""
            />
          </div>
        </div>
      </div>
      {filters && (
        <div className="w-100">
          <form className="form">
            <div className="form-row">
              <div className="col-sm-6 col-md-3 form-group">
                <label form="">Date range</label>
                <input
                  type="daterange"
                  id="search_checkout"
                  className="form-control"
                  placeholder="01-11-2022 - 01-12-2022"
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                />
              </div>
              {filterList.map((filter) => (
                <div className="col-sm-6 col-md-3 form-group">
                  <label form="">{filter.title}</label>
                  {getElement(filter)}
                  {/* <input
                    type={filter.type}
                    className="form-control"
                    placeholder="CryptoPunk"
                  /> */}
                </div>
              ))}
              <div className="col-sm-6 col-md-3 form-group">
                <label form="">NFT name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="CryptoPunk"
                />
              </div>
              <div className="col-sm-6 col-md-3 form-group">
                <label form="">Attributes</label>
                {/* <input
                  type="text"
                  className="form-control"
                  placeholder="Enter"
                /> */}
                {/* <select className="form-control">
                  <option></option>
                  <option>Hello</option>
                </select> */}
              </div>
              <div className="col-sm-6 col-md-3 form-group">
                <label form="">Original Owner</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter"
                />
              </div>
            </div>
            <span className="close" onClick={() => setFilters(false)}>
              <i className="fas fa-times float-right"></i>
            </span>
          </form>
          <div className="d-flex align-items-center apply-filter mt-4 mb-5">
            <div className="f-selectd">
              01-11-2022 / 01-12-2022{" "}
              <i className="fas fa-times float-right"></i>
            </div>
            <div className="f-selectd">
              CryptoPunk<i className="fas fa-times float-right"></i>
            </div>
            <a href="">Clear all filters</a>
          </div>
        </div>
      )}
    </>
  );
};

export default React.memo(FilterWrapper);
